import { store } from '../store';

export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    patch: request('PATCH'),
    delete: request('DELETE'),
    postSend: requestSend('POST'),
};

function requestSend(method) {
    return (url, body) => {
        const requestOptions = {
            method,
            headers: authHeader(url)
        };
        if (body) {
            requestOptions.headers['Content-Type'] = 'application/json';
           

            //requestOptions.headers['Access-Control-Allow-Origin'] = '*';
           
            requestOptions.body = JSON.stringify(body);
        }
       
        localStorage.getItem('customer-portal')
        return fetch(url, requestOptions).then(handleResponse);
    }
}

function request(method) {
    return (url, body) => {
        const requestOptions = {
            method,
            headers: authHeader(url)
        };
        if (body) {
            requestOptions.headers['Content-Type'] = 'application/json';
            
            //requestOptions.headers['Access-Control-Allow-Origin'] = '*';
           
            requestOptions.body = JSON.stringify(body);
        }
        requestOptions.headers['x-login-token'] = localStorage.getItem('login_token');
        requestOptions.headers['x-access-token'] = localStorage.getItem('customer-portal');
       
        return fetch(url, requestOptions).then(handleResponse);
    }
}

// helper functions

function authHeader(url) {
    // return auth header with jwt if user is logged in and request is to one of our own API bases.
    // XFlow calls (REACT_APP_FLOW_API_URL) are a separate backend from the main
    // API — without this, fetchWrapper calls made against it would silently go
    // out with no Authorization header instead of failing loudly.
    const token = authToken();
    const isLoggedIn = !!token;
    const isApiUrl = url.startsWith(process.env.REACT_APP_API_URL)
        || (process.env.REACT_APP_FLOW_API_URL && url.startsWith(process.env.REACT_APP_FLOW_API_URL));
    if (isLoggedIn && isApiUrl) {
        return { Authorization: `Bearer ${token}` };
    } else {
        return {};
    }
}

function authToken() {
    return store.getState().auth.user?.token;
}

function isJwtExpired(token) {
    if (!token || typeof token !== "string") return false;
    try {
        const parts = token.split(".");
        if (parts.length !== 3) return false;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));
        if (!payload.exp) return false;
        return Date.now() >= payload.exp * 1000;
    } catch (_) { return false; }
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);


        if (!response.ok) {
            // Only force-logout when the JWT is actually expired. Other 401/403s
            // (transient permission errors, post-restart Redis hash misses, etc.)
            // bubble as a normal rejection so the caller can show a toast and the
            // user stays signed in.
           
            if ([401, 403].includes(response.status)) {
                const token = localStorage.getItem("customer-portal");
                if (isJwtExpired(token) || response.status === 403) {
                    localStorage.clear();
                    window.location.href = "/";
                }
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}